import { Group } from "@/src/models/group";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getGroupForStytchOrgId(stytchOrgId: string): Promise<Group | null> {
  return fetchJSON<Group>(`/api/groups/${stytchOrgId}`);
}

export async function getGroupForSubdomain(subdomain: string): Promise<Group | null> {
  return await fetchJSON<Group | null>(`/api/groups/subdomain/${subdomain}`);
}
